var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagesV3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6059 0.880843C12.8574 0.773036 13.1422 0.773036 13.3937 0.880843L24.5937 5.68084C24.9614 5.83842 25.1998 6.19996 25.1998 6.59999C25.1998 7.00002 24.9614 7.36155 24.5937 7.51913L13.3937 12.3191C13.1422 12.4269 12.8574 12.4269 12.6059 12.3191L1.40589 7.51913C1.0382 7.36155 0.799805 7.00002 0.799805 6.59999C0.799805 6.19996 1.0382 5.83842 1.40589 5.68084L12.6059 0.880843ZM4.3384 6.59999L12.9998 10.312L21.6612 6.59999L12.9998 2.88796L4.3384 6.59999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7505 5.76514C25.0311 5.95018 25.2 6.26384 25.2 6.59998V19.4C25.2 19.8 24.9616 20.1615 24.5939 20.3191L13.3939 25.1191C13.085 25.2515 12.7301 25.2199 12.4495 25.0348C12.1689 24.8498 12 24.5361 12 24.2V11.4C12 11 12.2384 10.6384 12.6061 10.4808L23.8061 5.68083C24.115 5.54842 24.4699 5.58009 24.7505 5.76514ZM14 12.0594V22.6834L23.2 18.7406V8.11652L14 12.0594Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24931 5.76514C1.52994 5.58009 1.88476 5.54842 2.19372 5.68083L13.3937 10.4808C13.7614 10.6384 13.9998 11 13.9998 11.4V24.2C13.9998 24.5361 13.8309 24.8498 13.5503 25.0348C13.2697 25.2199 12.9149 25.2515 12.6059 25.1191L1.40589 20.3191C1.0382 20.1615 0.799805 19.8 0.799805 19.4V6.59998C0.799805 6.26384 0.968688 5.95018 1.24931 5.76514ZM2.7998 8.11652V18.7406L11.9998 22.6834V12.0594L2.7998 8.11652Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagesV3Icon);
export default __webpack_public_path__ + "static/media/packages-v3-icon.d14d7a986ec071be7c0b353aea62df8a.svg";
export { ForwardRef as ReactComponent };